import React, { useEffect, useState } from 'react';
import Indicator from '../../../../components/background-component-group/indicator/Indicator';
import IndicatorPreventInteraction from '../../../../components/background-component-group/indicator-prevent-interaction/IndicatorPreventInteraction';
import TransparentPreventInteraction from '../../../../components/background-component-group/transparent-prevent-interaction/TransparentPreventInteraction';
import { EventContainer } from '../../../redux/EventContainer';

/* types
  'indicator' = indicator animasyonunu oynatır, kullanıcı inputlarını engeelemez,
  'indicator-prevent-interaction' = indicator animasyonunu oynatır, kullanıcı inputlarını engeller,
  'transparent-prevent-interaction' = Ekranda hiçbirşey belirmez, kullanıcı inputlarını engeller,

extents
  'page-content' = kullanıcı inputlarını engelleme işlemini içerik ile sınırlı tutar, header ve footer kullanımını engellemez,
  'page' = kullanıcı inputlarını engelleme işlemini sayfanın her yeri için yapar, header ve footer kullanımını engeller,
  'this-component' = kullanıcı inputlarını engelleme işlemini belirtilen komponetler için gerçekleştirir.,
*/

/* TODO 'this-component ile komponent bazlı işlem engelleme yeteneği' */

export interface IndicatorOptionsOptional {
  type?: 'indicator' | 'indicator-prevent-interaction' | 'transparent-prevent-interaction';
  extent?: 'page' | 'page-content';
}

export interface IndicatorOptions {
  type: 'indicator' | 'indicator-prevent-interaction' | 'transparent-prevent-interaction';
  extent: 'page' | 'page-content';
}

const defaultIndicatorOptions: IndicatorOptions = {
  type: 'indicator-prevent-interaction',
  extent: 'page-content',
};

export let setLoading = (show: boolean, options?: IndicatorOptions | undefined, delay?: number | undefined): void => {
  const evt = EventContainer.CreateCustomEvent('trigger', { show: show, options: options });
  if (delay && delay > 0) {
    setTimeout(() => EventContainer.DispatchEvent(evt, 'IndicatorServices_SetLoading'), delay);
  } else {
    EventContainer.DispatchEvent(evt, 'IndicatorServices_SetLoading');
  }
};

export const IndicatorService = (options?: IndicatorOptionsOptional | undefined) => {
  const _options = { ...defaultIndicatorOptions, ...options };

  const [state, setState] = useState<{
    show: boolean;
    extent: 'page' | 'page-content';
    type: 'indicator' | 'indicator-prevent-interaction' | 'transparent-prevent-interaction';
  }>({ show: false, extent: _options.extent, type: _options.type });

  const _setLoading = (show: boolean, options?: IndicatorOptions | undefined) => {
    if (show === true) {
      const __options = { ..._options, ...options };
      setState({ show: true, extent: __options.extent, type: __options.type });
    } else {
      setState({ show: false, extent: _options.extent, type: _options.type });
    }
  };

  useEffect(() => {
    EventContainer.getEventTarget('IndicatorServices_SetLoading').addEventListener(
      'trigger',
      (e: any) => {
        _setLoading(e.detail.show, e.detail.options);
      }
    );
    return () => {
      EventContainer.getEventTarget('IndicatorServices_SetLoading').removeEventListener('trigger');
    };
  }, []);

  return state.type === 'indicator' ? (
    <Indicator loading={state.show}></Indicator>
  ) : state.type === 'indicator-prevent-interaction' ? (
    <IndicatorPreventInteraction
      loading={state.show}
      extent={state.extent}></IndicatorPreventInteraction>
  ) : state.type === 'transparent-prevent-interaction' ? (
    <TransparentPreventInteraction
      loading={state.show}
      extent={state.extent}></TransparentPreventInteraction>
  ) : (
    <></>
  );
};
